import * as React from 'react';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useVto } from '../../context/VtoProvider.js';

const TryOnButton = ({ variant ='outline' , onClick  })=>{
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    const { isVtoActive , isVtoFeatureEnabled , setVtoActive  } = useVto();
    const buttonSize = isPhone ? 'small' : 'medium';
    const startVTO = ()=>{
        setVtoActive(true);
        onClick && onClick();
    };
    if (!isVtoFeatureEnabled || isVtoActive) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('vto.callToAction'),
        "data-t": "vto-try-on-button",
        variant: variant,
        icon: "try-on",
        color: "primary",
        size: buttonSize,
        onClick: startVTO
    });
};

export { TryOnButton };
//# sourceMappingURL=TryOnButton.js.map
